var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateAccountWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FDAB29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8242 41.9902C33.5637 41.9902 40.6484 38.579 40.6484 34.3711C40.6484 30.1632 33.5637 26.7521 24.8242 26.7521C16.0847 26.7521 9 30.1632 9 34.3711C9 38.579 16.0847 41.9902 24.8242 41.9902Z",
    fill: "white",
    stroke: "#FDAB29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.825 30.2711C30.975 30.2711 35.9606 25.2856 35.9606 19.1356C35.9606 12.9856 30.975 8 24.825 8C18.675 8 13.6895 12.9856 13.6895 19.1356C13.6895 25.2856 18.675 30.2711 24.825 30.2711Z",
    fill: "white",
    stroke: "#FDAB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3571 35.4258H28.25V31.9258H33.3571H33.6071V31.6758V26.9258H37.3929V31.6758V31.9258H37.6429H42.75V35.4258H37.6429H37.3929V35.6758V41.4258H33.6071V35.6758V35.4258H33.3571Z",
    fill: "white",
    stroke: "#FDAB29",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccountWhite);
export default __webpack_public_path__ + "static/media/create-account-white.0e1c53f9b4863c53ba9facaad5461a89.svg";
export { ForwardRef as ReactComponent };